import { createGlobalStyle } from 'styled-components';
import { lcdNovaFontFace } from './fonts';

// Глобальные стили (классический дизайн), подключаются через libs/design
export const GlobalDesignStyle = createGlobalStyle`
${lcdNovaFontFace}
body {
  height: 100vh;
  width: 100vw;
  font-family: 'Roboto', sans-serif;
  margin: 0;
  padding: 0;
  background-color: #30353b;
  overflow: hidden;
}

.main {
  transform: scale(0.9);
}

input[disabled] {
  pointer-events: none;
}

.loading {
  position: relative;
}
.loading::after {
  content: '';
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  /* z-index: 9999; */
  border-radius: 10px;
  background: rgba(0, 0, 0, 0.7) url(images/loader2.svg) no-repeat 50% 50%;
  background-size: 20px;
}
.loading.simple::after {
  background-color: transparent;
}

.notification-info{
  background-color: #777;
  border-left-color: #555;
}
 .notification-info .timer{
  background-color: #555;
 }
 .notification-info.notification-item .notification-message{
  font-size: 12px;
 }
 .notification-info .notification-close{
  background-color: #333;
 }
 .notification-info .notification-close:hover{
  background-color: #000;
 }
 .react-notification-root{
  z-index: 90000 !important;
 }`;
